import axios from 'axios';
import i18n from "@/i18n";

export default {
    async getLatestMessage() {
        return await axios({
            url: '/api/messagecenter/latest',
        }).then(r => r.data);
    },
    async getMessages() {
        return await axios({
            url: '/api/messagecenter',
        }).then(r => r.data);
    },
    async getMessagesAdmin() {
        return await axios({
            url: '/api/messagecenter/admin',
        }).then(r => r.data);
    },
    async getMessage(id) {
        return await axios({
            url: '/api/messagecenter/' + id,
        })
            .then(r => r.data)
            .then(r => {
                return r;
            });
    },
    async updateMessage(id, /* Message */ data) {
        return await axios({
            url: '/api/messagecenter/' + id,
            method: 'put',
            data,
        }).then(r => r.data);
    },
    async createMessage(data) {
        return await axios({
            url: '/api/messagecenter/',
            method: 'post',
            data,
        }).then(r => r.data);
    },
    async deleteMessage(id) {
        return await axios({
            url: '/api/messagecenter/' + id,
            method: 'delete',
        }).then(r => r.data);
    },
    getCategories() {
        return [
            {text: i18n.t('message_center.categories.release_notes'), value: 'release_notes'},
            {text: i18n.t('message_center.categories.news'), value: 'news'},
        ]
    }
};
